import SettlementsList from "@/pages/Settlement/SettlementsList.vue";
import Settlement from "@/pages/Settlement/Settlement.vue";

export default [
  {
    path: "/settlements",
    name: "Settlements",
    component: SettlementsList,
    meta: { requiresAuth: true },
  },
  {
    path: "/settlements/add",
    name: "AddSettlement",
    component: Settlement,
    props: { isEdit: false },
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/settlements/:id",
  //   name: "EditSettlement",
  //   component: Settlement,
  //   props: (route) => ({ id: route.params.id, isEdit: true }),
  //   meta: { requiresAuth: true },
  // },
];
